import { useSuspenseQuery } from "@tanstack/react-query";
import { Skeleton } from "@/components/ui/skeleton";
import {
  useUserCounts,
  userCountsQueryOptions,
} from "../../service/organization";

interface UserCountCellProps {
  organizationId: string;
}

export function UserCountCell({ organizationId }: UserCountCellProps) {
  const { data: counts, isLoading } = useUserCounts(organizationId);

  if (isLoading) {
    return <Skeleton className="h-4 w-12" />;
  }

  return (
    <span>
      {counts?.total || 0} / {counts?.active || 0}
    </span>
  );
}

export function UserCountCellSuspense({ organizationId }: UserCountCellProps) {
  try {
    const { data: counts } = useSuspenseQuery(
      userCountsQueryOptions(organizationId),
    );

    return (
      <span>
        {counts?.total || 0} / {counts?.active || 0}
      </span>
    );
  } catch (error) {
    return <Skeleton className="h-4 w-12" />;
  }
}
